export default "__VITE_ASSET__B2RVuXKS__"